module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/nusajaya-2015.jpg?v=c3ceaa8b";